import { Datepicker } from 'vanillajs-datepicker'
import da from 'vanillajs-datepicker/locales/da'
import de from 'vanillajs-datepicker/locales/de'
import fr from 'vanillajs-datepicker/locales/fr'

Object.assign(Datepicker.locales, da, de, fr)

export default Datepicker
